export default function validatePhoneNumber(phoneNumber: string): boolean {
  return /^[\d]+$/.test(phoneNumber) && phoneNumber.length > 5;
}

export function validateDigitsOnly(phoneNumber: string): boolean {
  return /^[\d]*$/.test(phoneNumber);
}
